
const country = [{
  zh: '中国',
  en: 'China'
},
{
  zh: '韩国',
  en: 'Korea, South'
},
{
  zh: '日本',
  en: 'Japan'
},
{
  zh: '泰国',
  en: 'Thailand'
},
{
  zh: '阿布哈兹',
  en: 'Abkhazia'
},
{
  zh: '阿富汗',
  en: 'Afghanistan'
},
{
  zh: '阿尔巴尼亚',
  en: 'Albania'
},
{
  zh: '阿尔及利亚',
  en: 'Algeria'
},
{
  zh: '安道尔',
  en: 'Andorra'
},
{
  zh: '安哥拉',
  en: 'Angola'
},
{
  zh: '安提瓜和巴布达',
  en: 'Antigua and Barbuda'
},
{
  zh: '阿根廷',
  en: 'Argentina'
},
{
  zh: '亚美尼亚',
  en: 'Armenia'
},
{
  zh: '澳大利亚',
  en: 'Australia'
},
{
  zh: '奥地利',
  en: 'Austria'
},
{
  zh: '阿塞拜疆',
  en: 'Azerbaijan'
},
{
  zh: '巴哈马',
  en: 'Commonwealth oftheBahamas'
},
{
  zh: '巴林',
  en: 'Bahrain'
},
{
  zh: '孟加拉国',
  en: 'Bangladesh'
},
{
  zh: '巴巴多斯',
  en: 'Barbados'
},
{
  zh: '白俄罗斯',
  en: 'Belarus'
},
{
  zh: '比利时',
  en: 'Belgium'
},
{
  zh: '伯利兹',
  en: 'Belize'
},
{
  zh: '贝宁',
  en: 'Benin'
},
{
  zh: '不丹',
  en: 'Bhutan'
},
{
  zh: '玻利维亚',
  en: 'Bolivia'
},
{
  zh: '波黑',
  en: 'Bosnia and Herzegovina'
},
{
  zh: '博茨瓦纳',
  en: 'Botswana'
},
{
  zh: '巴西',
  en: 'Brazil'
},
{
  zh: '文莱',
  en: 'Brunei'
},
{
  zh: '保加利亚',
  en: 'Bulgaria'
},
{
  zh: '布基纳法索',
  en: 'Burkina Faso'
},
{
  zh: '布隆迪',
  en: 'Burundi'
},
{
  zh: '柬埔寨',
  en: 'Cambodia'
},
{
  zh: '喀麦隆',
  en: 'Cameroon'
},
{
  zh: '加拿大',
  en: 'Canada'
},
{
  zh: '佛得角',
  en: 'Cape Verde'
},
{
  zh: '加泰罗尼亚',
  en: 'Catalen'
},
{
  zh: '中非共和国',
  en: 'Central African Republic'
},
{
  zh: '乍得',
  en: 'Chad'
},
{
  zh: '智利',
  en: 'Chile'
},
{
  zh: '哥伦比亚',
  en: 'Colombia'
},
{
  zh: '科摩罗',
  en: 'Comoros'
},
{
  zh: '刚果共和国',
  en: 'Congo (Brazzaville)'
},
{
  zh: '刚果民主共和国',
  en: 'Congo (Kinshasa)'
},
{
  zh: '库克群岛',
  en: 'Cook Islands'
},
{
  zh: '哥斯达黎加',
  en: 'Costa Rica'
},
{
  zh: '科特迪瓦',
  en: 'Côte d\'Ivoire'
},
{
  zh: '克罗地亚',
  en: 'Croatia'
},
{
  zh: '古巴',
  en: 'Cuba'
},
{
  zh: '塞浦路斯',
  en: 'Cyprus'
},
{
  zh: '捷克',
  en: 'Czech Republic'
},
{
  zh: '丹麦',
  en: 'Denmark'
},
{
  zh: '吉布提',
  en: 'Djibouti'
},
{
  zh: '顿涅茨克',
  en: 'Donetsk People\'s Republic'
},
{
  zh: '多米尼克',
  en: 'Dominica'
},
{
  zh: '多米尼加',
  en: 'Dominican Republic'
},
{
  zh: '厄瓜多尔',
  en: 'Ecuador'
},
{
  zh: '埃及',
  en: 'Egypt'
},
{
  zh: '萨尔瓦多',
  en: 'El Salvador'
},
{
  zh: '赤道几内亚',
  en: 'Equatorial Guinea'
},
{
  zh: '厄立特里亚',
  en: 'Eritrea'
},
{
  zh: '爱沙尼亚',
  en: 'Estonia'
},
{
  zh: '埃塞俄比亚',
  en: 'Ethiopia'
},
{
  zh: '斐济',
  en: 'Fiji'
},
{
  zh: '芬兰',
  en: 'Finland'
},
{
  zh: '法国',
  en: 'France'
},
{
  zh: '加蓬',
  en: 'Gabon'
},
{
  zh: '冈比亚',
  en: 'Gambia'
},
{
  zh: '格鲁吉亚',
  en: 'Georgia'
},
{
  zh: '德国',
  en: 'Germany'
},
{
  zh: '加纳',
  en: 'Ghana'
},
{
  zh: '希腊',
  en: 'Greece'
},
{
  zh: '格林纳达',
  en: 'Grenada'
},
{
  zh: '危地马拉',
  en: 'Guatemala'
},
{
  zh: '几内亚',
  en: 'Guinea'
},
{
  zh: '几内亚比绍',
  en: 'Guinea-Bissau'
},
{
  zh: '圭亚那',
  en: 'Guyana'
},
{
  zh: '海地',
  en: 'Haiti'
},
{
  zh: '洪都拉斯',
  en: 'Honduras'
},
{
  zh: '匈牙利',
  en: 'Hungary'
},
{
  zh: '冰岛',
  en: 'Iceland'
},
{
  zh: '印度',
  en: 'India'
},
{
  zh: '印度尼西亚',
  en: 'Indonesia'
},
{
  zh: '伊朗',
  en: 'Iran'
},
{
  zh: '伊拉克',
  en: 'Iraq'
},
{
  zh: '爱尔兰',
  en: 'Ireland'
},
{
  zh: '以色列',
  en: 'Israel'
},
{
  zh: '意大利',
  en: 'Italy'
},
{
  zh: '牙买加',
  en: 'Jamaica'
},
{
  zh: '约旦',
  en: 'Jordan'
},
{
  zh: '哈萨克斯坦',
  en: 'Kazakhstan'
},
{
  zh: '肯尼亚',
  en: 'Kenya'
},
{
  zh: '基里巴斯',
  en: 'Kiribati'
},
{
  zh: '科索沃',
  en: 'Kosovo'
},
{
  zh: '科威特',
  en: 'Kuwait'
},
{
  zh: '吉尔吉斯斯坦',
  en: 'Kyrgyzstan'
},
{
  zh: '老挝',
  en: 'Laos'
},
{
  zh: '拉脱维亚',
  en: 'Latvia'
},
{
  zh: '黎巴嫩',
  en: 'Lebanon'
},
{
  zh: '莱索托',
  en: 'Lesotho'
},
{
  zh: '利比里亚',
  en: 'Liberia'
},
{
  zh: '利比亚',
  en: 'Libya'
},
{
  zh: '列支敦士登',
  en: 'Liechtenstein'
},
{
  zh: '立陶宛',
  en: 'Lithuania'
},
{
  zh: '卢森堡',
  en: 'Luxembourg'
},
{
  zh: '马达加斯加',
  en: 'Madagascar'
},
{
  zh: '马拉维',
  en: 'Malawi'
},
{
  zh: '马来西亚',
  en: 'Malaysia'
},
{
  zh: '马尔代夫',
  en: 'Maldives'
},
{
  zh: '马耳他骑士团',
  en: 'Maltese Knights'
},
{
  zh: '马里',
  en: 'Mali'
},
{
  zh: '马耳他',
  en: 'Malta'
},
{
  zh: '马绍尔群岛',
  en: 'Marshall Islands'
},
{
  zh: '毛里塔尼亚',
  en: 'Mauritania'
},
{
  zh: '毛里求斯',
  en: 'Mauritius'
},
{
  zh: '墨西哥',
  en: 'Mexico'
},
{
  zh: '密克罗尼西亚联邦',
  en: 'Micronesia'
},
{
  zh: '摩尔多瓦',
  en: 'Moldova'
},
{
  zh: '摩纳哥',
  en: 'Monaco'
},
{
  zh: '蒙古国',
  en: 'Mongolia'
},
{
  zh: '黑山',
  en: 'Montenegro'
},
{
  zh: '摩洛哥',
  en: 'Morocco'
},
{
  zh: '莫桑比克',
  en: 'Mozambique'
},
{
  zh: '缅甸',
  en: 'Myanmar'
},
{
  zh: '纳戈尔诺-卡拉巴赫',
  en: 'Nagorno-Karabakh'
},
{
  zh: '纳米比亚',
  en: 'Namibia'
},
{
  zh: '瑙鲁',
  en: 'Nauru'
},
{
  zh: '尼泊尔',
  en: 'Nepal'
},
{
  zh: '荷兰',
  en: 'Netherlands'
},
{
  zh: '新西兰',
  en: 'New Zealand'
},
{
  zh: '尼加拉瓜',
  en: 'Nicaragua'
},
{
  zh: '尼日尔',
  en: 'Niger'
},
{
  zh: '尼日利亚',
  en: 'Nigeria'
},
{
  zh: '纽埃',
  en: 'Niue'
},
{
  zh: '北塞浦路斯',
  en: 'Northern Cyprus'
},
{
  zh: '北马其顿',
  en: 'North Macedonia'
},
{
  zh: '挪威',
  en: 'Norway'
},
{
  zh: '阿曼',
  en: 'Oman'
},
{
  zh: '巴基斯坦',
  en: 'Pakistan'
},
{
  zh: '帕劳',
  en: 'Palau'
},
{
  zh: '巴勒斯坦',
  en: 'Palestine'
},
{
  zh: '巴拿马',
  en: 'Panama'
},
{
  zh: '巴布亚新几内亚',
  en: 'Papua New Guinea'
},
{
  zh: '巴拉圭',
  en: 'Paraguay'
},
{
  zh: '朝鲜',
  en: 'People\'s Republic of Korea'
},
{
  zh: '秘鲁',
  en: 'Peru'
},
{
  zh: '菲律宾',
  en: 'Philippines'
},
{
  zh: '波兰',
  en: 'Poland'
},
{
  zh: '葡萄牙',
  en: 'Portugal'
},
{
  zh: '德涅斯特河沿岸',
  en: 'Pridnestrovie'
},
{
  zh: '邦特兰',
  en: 'Puntland'
},
{
  zh: '卡塔尔',
  en: 'Qatar'
},
{
  zh: '罗马尼亚',
  en: 'Romania'
},
{
  zh: '俄罗斯',
  en: 'Russia'
},
{
  zh: '卢旺达',
  en: 'Rwanda'
},
{
  zh: '圣基茨和尼维斯',
  en: 'Saint Christopher and Nevis'
},
{
  zh: '圣卢西亚',
  en: 'Saint Lucia'
},
{
  zh: '圣文森特和格林纳丁斯',
  en: 'Saint Vincent and the Grenadines'
},
{
  zh: '萨摩亚',
  en: 'Samoa'
},
{
  zh: '圣马力诺',
  en: 'San Marino'
},
{
  zh: '圣多美和普林西比',
  en: 'São Tomé and Príncipe'
},
{
  zh: '沙特阿拉伯',
  en: 'Saudi Arabia'
},
{
  zh: '塞内加尔',
  en: 'Senegal'
},
{
  zh: '塞尔维亚',
  en: 'Serbia'
},
{
  zh: '塞舌尔',
  en: 'Seychelles'
},
{
  zh: '塞拉利昂',
  en: 'Sierra Leone'
},
{
  zh: '新加坡',
  en: 'Singapore'
},
{
  zh: '斯洛伐克',
  en: 'Slovakia'
},
{
  zh: '斯洛文尼亚',
  en: 'Slovenia'
},
{
  zh: '所罗门群岛',
  en: 'Solomon Islands'
},
{
  zh: '索马里',
  en: 'Somali'
},
{
  zh: '索马里兰',
  en: 'Somaliland'
},
{
  zh: '南非',
  en: 'South Africa'
},
{
  zh: '南奥塞梯',
  en: 'South Ossetia'
},
{
  zh: '南苏丹',
  en: 'South Sudan'
},
{
  zh: '西班牙',
  en: 'Spain'
},
{
  zh: '斯里兰卡',
  en: 'Sri Lanka'
},
{
  zh: '苏丹',
  en: 'Sudan'
},
{
  zh: '苏里南',
  en: 'Suriname'
},
{
  zh: '斯威士兰',
  en: 'Swaziland'
},
{
  zh: '瑞典',
  en: 'Sweden'
},
{
  zh: '瑞士',
  en: 'Switzerland'
},
{
  zh: '叙利亚',
  en: 'Syria'
},
{
  zh: '塔吉克斯坦',
  en: 'Tajikistan'
},
{
  zh: '坦桑尼亚',
  en: 'Tanzania'
},
{
  zh: '东帝汶',
  en: 'Timor-Leste'
},
{
  zh: '多哥',
  en: 'Togo'
},
{
  zh: '汤加',
  en: 'Tonga'
},
{
  zh: '特立尼达和多巴哥',
  en: 'Trinidad and Tobago'
},
{
  zh: '突尼斯',
  en: 'Tunisia'
},
{
  zh: '土耳其',
  en: 'Turkey'
},
{
  zh: '土库曼斯坦',
  en: 'Turkmenistan'
},
{
  zh: '图瓦卢',
  en: 'Tuvalu'
},
{
  zh: '乌干达',
  en: 'Uganda'
},
{
  zh: '乌克兰',
  en: 'Ukraine'
},
{
  zh: '阿联酋',
  en: 'United Arab Emirates'
},
{
  zh: '英国',
  en: 'United Kingdom'
},
{
  zh: '美国',
  en: 'United States'
},
{
  zh: '乌拉圭',
  en: 'Uruguay'
},
{
  zh: '乌兹别克斯坦',
  en: 'Uzbekistan'
},
{
  zh: '瓦努阿图',
  en: 'Vanuatu'
},
{
  zh: '梵蒂冈',
  en: 'Vatican city（the Holy see)'
},
{
  zh: '委内瑞拉',
  en: 'Venezuela'
},
{
  zh: '越南',
  en: 'Vietnam'
},
{
  zh: '西撒哈拉',
  en: 'Western Sahara'
},
{
  zh: '也门',
  en: 'Yemen'
},
{
  zh: '赞比亚',
  en: 'Zambia'
},
{
  zh: '津巴布韦',
  en: 'Zimbabwe'
},
{
  zh: '台湾地区',
  en: 'Taiwan'
},
{
  zh: '香港地区',
  en: 'Hong Kong'
},
{
  zh: '澳门地区',
  en: 'Macao'
}]

const countryFormat = (() => {
  const obj = {
    zh: [],
    en: []
  }
  for (const i in country) {
    obj.zh.push(country[i]['zh'])
    obj.en.push(country[i]['en'])
  }
  return obj
})()

export default countryFormat
